window.TRADEIN_DATA =
[
  {
    "Modelo": "iPhone XR | 64GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 100,
    "Precio recibido orange": 100,
    "Precio venta": 145,
    "BATERIA": 35,
    "MICA": 40,
    "PANTALLA": 40,
    "TAPA": 30,
    "CHASIS": 50,
    "CAMARA TRASERA": 40,
    "FACE ID": 40,
    "AURICULAR": 20,
    "CRISTAL DE CAMARA": 15,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 40,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone XR | 128GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 120,
    "Precio recibido orange": 120,
    "Precio venta": 160,
    "BATERIA": 35,
    "MICA": 40,
    "PANTALLA": 40,
    "TAPA": 30,
    "CHASIS": 50,
    "CAMARA TRASERA": 40,
    "FACE ID": 40,
    "AURICULAR": 20,
    "CRISTAL DE CAMARA": 15,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 40,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 11 | 64GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 110,
    "Precio recibido orange": 110,
    "Precio venta": 200,
    "BATERIA": 40,
    "MICA": 40,
    "PANTALLA": 50,
    "TAPA": 40,
    "CHASIS": 50,
    "CAMARA TRASERA": 50,
    "FACE ID": 40,
    "AURICULAR": 20,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 50,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 11 | 128GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 125,
    "Precio recibido orange": 125,
    "Precio venta": 245,
    "BATERIA": 40,
    "MICA": 40,
    "PANTALLA": 50,
    "TAPA": 40,
    "CHASIS": 50,
    "CAMARA TRASERA": 50,
    "FACE ID": 40,
    "AURICULAR": 20,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 50,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 11 | 256GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 140,
    "Precio recibido orange": 140,
    "Precio venta": 290,
    "BATERIA": 40,
    "MICA": 40,
    "PANTALLA": 50,
    "TAPA": 40,
    "CHASIS": 50,
    "CAMARA TRASERA": 50,
    "FACE ID": 40,
    "AURICULAR": 20,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 50,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 11 Pro | 256GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 160,
    "Precio recibido orange": 160,
    "Precio venta": 245,
    "BATERIA": 55,
    "MICA": 50,
    "PANTALLA": 80,
    "TAPA": 45,
    "CHASIS": 60,
    "CAMARA TRASERA": 60,
    "FACE ID": 40,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 11 Pro | 512GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 170,
    "Precio recibido orange": 170,
    "Precio venta": 345,
    "BATERIA": 55,
    "MICA": 50,
    "PANTALLA": 80,
    "TAPA": 45,
    "CHASIS": 60,
    "CAMARA TRASERA": 60,
    "FACE ID": 40,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 11 Pro | 64GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 140,
    "Precio recibido orange": 140,
    "Precio venta": 245,
    "BATERIA": 55,
    "MICA": 50,
    "PANTALLA": 80,
    "TAPA": 45,
    "CHASIS": 60,
    "CAMARA TRASERA": 60,
    "FACE ID": 40,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 11 Pro Max | 256GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 170,
    "Precio recibido orange": 170,
    "Precio venta": 285,
    "BATERIA": 60,
    "MICA": 50,
    "PANTALLA": 80,
    "TAPA": 45,
    "CHASIS": 60,
    "CAMARA TRASERA": 60,
    "FACE ID": 40,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 11 Pro Max | 512GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 180,
    "Precio recibido orange": 180,
    "Precio venta": 350,
    "BATERIA": 60,
    "MICA": 50,
    "PANTALLA": 80,
    "TAPA": 45,
    "CHASIS": 60,
    "CAMARA TRASERA": 60,
    "FACE ID": 40,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 11 Pro Max | 64GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 150,
    "Precio recibido orange": 150,
    "Precio venta": 300,
    "BATERIA": 60,
    "MICA": 50,
    "PANTALLA": 80,
    "TAPA": 45,
    "CHASIS": 60,
    "CAMARA TRASERA": 60,
    "FACE ID": 40,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 12 | 64GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 160,
    "Precio recibido orange": 155,
    "Precio venta": 245,
    "BATERIA": 50,
    "MICA": 50,
    "PANTALLA": 100,
    "TAPA": 50,
    "CHASIS": 80,
    "CAMARA TRASERA": 60,
    "FACE ID": 50,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 12 | 128GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 180,
    "Precio recibido orange": 175,
    "Precio venta": 280,
    "BATERIA": 50,
    "MICA": 50,
    "PANTALLA": 100,
    "TAPA": 50,
    "CHASIS": 80,
    "CAMARA TRASERA": 60,
    "FACE ID": 50,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 12 | 256GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 200,
    "Precio recibido orange": 200,
    "Precio venta": 340,
    "BATERIA": 50,
    "MICA": 50,
    "PANTALLA": 100,
    "TAPA": 50,
    "CHASIS": 80,
    "CAMARA TRASERA": 60,
    "FACE ID": 50,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 12 Pro | 128GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 200,
    "Precio recibido orange": 200,
    "Precio venta": 355,
    "BATERIA": 50,
    "MICA": 55,
    "PANTALLA": 100,
    "TAPA": 50,
    "CHASIS": 80,
    "CAMARA TRASERA": 120,
    "FACE ID": 60,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 12 Pro | 256GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 220,
    "Precio recibido orange": 220,
    "Precio venta": 385,
    "BATERIA": 50,
    "MICA": 55,
    "PANTALLA": 100,
    "TAPA": 50,
    "CHASIS": 80,
    "CAMARA TRASERA": 120,
    "FACE ID": 60,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 12 Pro | 512GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 230,
    "Precio recibido orange": 230,
    "Precio venta": 415,
    "BATERIA": 50,
    "MICA": 55,
    "PANTALLA": 100,
    "TAPA": 50,
    "CHASIS": 80,
    "CAMARA TRASERA": 120,
    "FACE ID": 60,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 30,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 12 Pro Max | 128GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 260,
    "Precio recibido orange": 260,
    "Precio venta": 405,
    "BATERIA": 60,
    "MICA": 55,
    "PANTALLA": 160,
    "TAPA": 45,
    "CHASIS": 80,
    "CAMARA TRASERA": 120,
    "FACE ID": 100,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 40,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 12 Pro Max | 256GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 280,
    "Precio recibido orange": 280,
    "Precio venta": 445,
    "BATERIA": 60,
    "MICA": 55,
    "PANTALLA": 160,
    "TAPA": 45,
    "CHASIS": 100,
    "CAMARA TRASERA": 120,
    "FACE ID": 100,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 40,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 12 Pro Max | 512GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 315,
    "Precio recibido orange": 315,
    "Precio venta": 485,
    "BATERIA": 60,
    "MICA": 55,
    "PANTALLA": 160,
    "TAPA": 45,
    "CHASIS": 100,
    "CAMARA TRASERA": 120,
    "FACE ID": 100,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 40,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 13 | 128GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 245,
    "Precio recibido orange": 245,
    "Precio venta": 345,
    "BATERIA": 50,
    "MICA": 55,
    "PANTALLA": 80,
    "TAPA": 55,
    "CHASIS": 100,
    "CAMARA TRASERA": 80,
    "FACE ID": 80,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 40,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 13 | 256GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 275,
    "Precio recibido orange": 275,
    "Precio venta": 420,
    "BATERIA": 50,
    "MICA": 55,
    "PANTALLA": 80,
    "TAPA": 55,
    "CHASIS": 100,
    "CAMARA TRASERA": 80,
    "FACE ID": 80,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 40,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 13 | 512GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 300,
    "Precio recibido orange": 300,
    "Precio venta": 350,
    "BATERIA": 50,
    "MICA": 55,
    "PANTALLA": 80,
    "TAPA": 55,
    "CHASIS": 100,
    "CAMARA TRASERA": 80,
    "FACE ID": 80,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 20,
    "FLEX BOTONES": 40,
    "FLEX DE CARGA": 60,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 13 Pro | 128GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 330,
    "Precio recibido orange": 330,
    "Precio venta": 460,
    "BATERIA": 55,
    "MICA": 60,
    "PANTALLA": 160,
    "TAPA": 60,
    "CHASIS": 180,
    "CAMARA TRASERA": 140,
    "FACE ID": 100,
    "AURICULAR": 50,
    "CRISTAL DE CAMARA": 25,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 80,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 13 Pro | 256GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 360,
    "Precio recibido orange": 360,
    "Precio venta": 495,
    "BATERIA": 55,
    "MICA": 60,
    "PANTALLA": 160,
    "TAPA": 60,
    "CHASIS": 180,
    "CAMARA TRASERA": 140,
    "FACE ID": 100,
    "AURICULAR": 50,
    "CRISTAL DE CAMARA": 25,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 80,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 13 Pro | 512GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 380,
    "Precio recibido orange": 380,
    "Precio venta": 535,
    "BATERIA": 55,
    "MICA": 60,
    "PANTALLA": 160,
    "TAPA": 60,
    "CHASIS": 180,
    "CAMARA TRASERA": 140,
    "FACE ID": 100,
    "AURICULAR": 50,
    "CRISTAL DE CAMARA": 25,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 80,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 13 Pro Max | 128GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 385,
    "Precio recibido orange": 385,
    "Precio venta": 545,
    "BATERIA": 55,
    "MICA": 65,
    "PANTALLA": 200,
    "TAPA": 65,
    "CHASIS": 180,
    "CAMARA TRASERA": 140,
    "FACE ID": 100,
    "AURICULAR": 50,
    "CRISTAL DE CAMARA": 25,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 80,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 13 Pro Max | 256GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 415,
    "Precio recibido orange": 415,
    "Precio venta": 565,
    "BATERIA": 55,
    "MICA": 65,
    "PANTALLA": 200,
    "TAPA": 65,
    "CHASIS": 180,
    "CAMARA TRASERA": 140,
    "FACE ID": 100,
    "AURICULAR": 50,
    "CRISTAL DE CAMARA": 25,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 80,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 13 Pro Max | 512GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 425,
    "Precio recibido orange": 425,
    "Precio venta": 635,
    "BATERIA": 55,
    "MICA": 65,
    "PANTALLA": 200,
    "TAPA": 65,
    "CHASIS": 180,
    "CAMARA TRASERA": 140,
    "FACE ID": 100,
    "AURICULAR": 50,
    "CRISTAL DE CAMARA": 25,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 80,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 14 | 128GB | E-Sim | Usado",
    "Precio recibido iphonizate": 275,
    "Precio recibido orange": 275,
    "Precio venta": 390,
    "BATERIA": 60,
    "MICA": 65,
    "PANTALLA": 120,
    "TAPA": 65,
    "CHASIS": 180,
    "CAMARA TRASERA": 80,
    "FACE ID": 100,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 80,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 14 | 256GB | E-Sim | Usado",
    "Precio recibido iphonizate": 300,
    "Precio recibido orange": 300,
    "Precio venta": 455,
    "BATERIA": 60,
    "MICA": 65,
    "PANTALLA": 120,
    "TAPA": 65,
    "CHASIS": 120,
    "CAMARA TRASERA": 80,
    "FACE ID": 100,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 80,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 14 | 512GB | E-Sim | Usado",
    "Precio recibido iphonizate": 310,
    "Precio recibido orange": 310,
    "Precio venta": 390,
    "BATERIA": 60,
    "MICA": 65,
    "PANTALLA": 120,
    "TAPA": 65,
    "CHASIS": 120,
    "CAMARA TRASERA": 80,
    "FACE ID": 100,
    "AURICULAR": 40,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 80,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 14 Plus | 128GB | E-Sim | Usado",
    "Precio recibido iphonizate": 295,
    "Precio recibido orange": 295,
    "Precio venta": 425,
    "BATERIA": 60,
    "MICA": 70,
    "PANTALLA": 180,
    "TAPA": 70,
    "CHASIS": 120,
    "CAMARA TRASERA": 80,
    "FACE ID": 150,
    "AURICULAR": 50,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 80,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 14 Plus | 256GB | E-Sim | Usado",
    "Precio recibido iphonizate": 325,
    "Precio recibido orange": 325,
    "Precio venta": 430,
    "BATERIA": 60,
    "MICA": 70,
    "PANTALLA": 180,
    "TAPA": 70,
    "CHASIS": 120,
    "CAMARA TRASERA": 100,
    "FACE ID": 150,
    "AURICULAR": 50,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 80,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 14 Pro | 128GB | E-Sim | Usado",
    "Precio recibido iphonizate": 385,
    "Precio recibido orange": 385,
    "Precio venta": 545,
    "BATERIA": 60,
    "MICA": 70,
    "PANTALLA": 200,
    "TAPA": 70,
    "CHASIS": 200,
    "CAMARA TRASERA": 120,
    "FACE ID": 150,
    "AURICULAR": 60,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 100,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 14 Pro | 256GB | E-Sim | Usado",
    "Precio recibido iphonizate": 405,
    "Precio recibido orange": 405,
    "Precio venta": 580,
    "BATERIA": 60,
    "MICA": 70,
    "PANTALLA": 200,
    "TAPA": 70,
    "CHASIS": 200,
    "CAMARA TRASERA": 120,
    "FACE ID": 150,
    "AURICULAR": 60,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 100,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 14 Pro | 512GB | E-Sim | Usado",
    "Precio recibido iphonizate": 425,
    "Precio recibido orange": 425,
    "Precio venta": 605,
    "BATERIA": 60,
    "MICA": 70,
    "PANTALLA": 200,
    "TAPA": 70,
    "CHASIS": 200,
    "CAMARA TRASERA": 120,
    "FACE ID": 150,
    "AURICULAR": 60,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 100,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 14 Pro | 1TB | E-Sim | Usado",
    "Precio recibido iphonizate": 435,
    "Precio recibido orange": 435,
    "Precio venta": 665,
    "BATERIA": 60,
    "MICA": 70,
    "PANTALLA": 200,
    "TAPA": 70,
    "CHASIS": 200,
    "CAMARA TRASERA": 120,
    "FACE ID": 150,
    "AURICULAR": 60,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 100,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 14 Pro Max | 128GB | E-Sim | Usado",
    "Precio recibido iphonizate": 445,
    "Precio recibido orange": 445,
    "Precio venta": 610,
    "BATERIA": 70,
    "MICA": 75,
    "PANTALLA": 300,
    "TAPA": 75,
    "CHASIS": 200,
    "CAMARA TRASERA": 120,
    "FACE ID": 150,
    "AURICULAR": 60,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 100,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 14 Pro Max | 256GB | E-Sim | Usado",
    "Precio recibido iphonizate": 475,
    "Precio recibido orange": 475,
    "Precio venta": 675,
    "BATERIA": 70,
    "MICA": 75,
    "PANTALLA": 300,
    "TAPA": 75,
    "CHASIS": 200,
    "CAMARA TRASERA": 120,
    "FACE ID": 150,
    "AURICULAR": 60,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 100,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 14 Pro Max | 512GB | E-Sim | Usado",
    "Precio recibido iphonizate": 490,
    "Precio recibido orange": 490,
    "Precio venta": 745,
    "BATERIA": 70,
    "MICA": 75,
    "PANTALLA": 300,
    "TAPA": 75,
    "CHASIS": 200,
    "CAMARA TRASERA": 120,
    "FACE ID": 150,
    "AURICULAR": 60,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 100,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 14 Pro Max | 1TB | E-Sim | Usado",
    "Precio recibido iphonizate": 500,
    "Precio recibido orange": 500,
    "Precio venta": 775,
    "BATERIA": 70,
    "MICA": 75,
    "PANTALLA": 300,
    "TAPA": 75,
    "CHASIS": 200,
    "CAMARA TRASERA": 120,
    "FACE ID": 150,
    "AURICULAR": 60,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 100,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 | 128GB | E-Sim | Usado",
    "Precio recibido iphonizate": 380,
    "Precio recibido orange": 380,
    "Precio venta": 505,
    "BATERIA": 90,
    "MICA": 80,
    "PANTALLA": 250,
    "TAPA": 80,
    "CHASIS": 200,
    "CAMARA TRASERA": 100,
    "FACE ID": 150,
    "AURICULAR": 60,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 100,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 | 128GB | Single-Sim | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 520,
    "BATERIA": 90,
    "MICA": 80,
    "PANTALLA": 250,
    "TAPA": 80,
    "CHASIS": 200,
    "CAMARA TRASERA": 100,
    "FACE ID": 150,
    "AURICULAR": 60,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 100,
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 15 | 256GB | E-Sim | Usado",
    "Precio recibido iphonizate": 410,
    "Precio recibido orange": 410,
    "Precio venta": 565,
    "BATERIA": 90,
    "MICA": 80,
    "PANTALLA": 250,
    "TAPA": 80,
    "CHASIS": 200,
    "CAMARA TRASERA": 100,
    "FACE ID": 150,
    "AURICULAR": 60,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 100,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 | 512GB | E-Sim | Usado",
    "Precio recibido iphonizate": 410,
    "Precio recibido orange": 410,
    "Precio venta": 545,
    "BATERIA": 90,
    "MICA": 80,
    "PANTALLA": 250,
    "TAPA": 80,
    "CHASIS": 200,
    "CAMARA TRASERA": 100,
    "FACE ID": 150,
    "AURICULAR": 60,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 100,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 | 512GB | Single-Sim | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 625,
    "BATERIA": 90,
    "MICA": 80,
    "PANTALLA": 250,
    "TAPA": 80,
    "CHASIS": 200,
    "CAMARA TRASERA": 100,
    "FACE ID": 150,
    "AURICULAR": 60,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 100,
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 15 Plus | 128GB | E-Sim | Usado",
    "Precio recibido iphonizate": 410,
    "Precio recibido orange": 410,
    "Precio venta": 590,
    "BATERIA": 90,
    "MICA": 140,
    "PANTALLA": 300,
    "TAPA": 80,
    "CHASIS": 200,
    "CAMARA TRASERA": 150,
    "FACE ID": 150,
    "AURICULAR": 60,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 100,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Plus | 256GB | E-Sim | Usado",
    "Precio recibido iphonizate": 430,
    "Precio recibido orange": 430,
    "Precio venta": 615,
    "BATERIA": 90,
    "MICA": 140,
    "PANTALLA": 300,
    "TAPA": 80,
    "CHASIS": 200,
    "CAMARA TRASERA": 150,
    "FACE ID": 150,
    "AURICULAR": 60,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 100,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Plus | 512GB | E-Sim | Usado",
    "Precio recibido iphonizate": 440,
    "Precio recibido orange": 440,
    "Precio venta": 615,
    "BATERIA": 90,
    "MICA": 140,
    "PANTALLA": 300,
    "TAPA": 80,
    "CHASIS": 200,
    "CAMARA TRASERA": 150,
    "FACE ID": 150,
    "AURICULAR": 60,
    "CRISTAL DE CAMARA": 30,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 100,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Pro | 128GB | E-Sim | Usado",
    "Precio recibido iphonizate": 445,
    "Precio recibido orange": 445,
    "Precio venta": 640,
    "BATERIA": 95,
    "MICA": 90,
    "PANTALLA": 320,
    "TAPA": 90,
    "CHASIS": 300,
    "CAMARA TRASERA": 150,
    "FACE ID": 180,
    "AURICULAR": 80,
    "CRISTAL DE CAMARA": 35,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 150,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Pro | 256GB | E-Sim | Usado",
    "Precio recibido iphonizate": 470,
    "Precio recibido orange": 470,
    "Precio venta": 700,
    "BATERIA": 95,
    "MICA": 90,
    "PANTALLA": 320,
    "TAPA": 90,
    "CHASIS": 300,
    "CAMARA TRASERA": 150,
    "FACE ID": 180,
    "AURICULAR": 80,
    "CRISTAL DE CAMARA": 35,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 150,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Pro | 512GB | E-Sim | Usado",
    "Precio recibido iphonizate": 485,
    "Precio recibido orange": 485,
    "Precio venta": 750,
    "BATERIA": 95,
    "MICA": 90,
    "PANTALLA": 320,
    "TAPA": 90,
    "CHASIS": 300,
    "CAMARA TRASERA": 150,
    "FACE ID": 180,
    "AURICULAR": 80,
    "CRISTAL DE CAMARA": 35,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 150,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Pro | 1TB | E-Sim | Usado",
    "Precio recibido iphonizate": 495,
    "Precio recibido orange": 495,
    "Precio venta": 800,
    "BATERIA": 95,
    "MICA": 90,
    "PANTALLA": 320,
    "TAPA": 90,
    "CHASIS": 300,
    "CAMARA TRASERA": 150,
    "FACE ID": 180,
    "AURICULAR": 80,
    "CRISTAL DE CAMARA": 35,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 150,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Pro Max | 256GB | E-Sim | Usado",
    "Precio recibido iphonizate": 550,
    "Precio recibido orange": 550,
    "Precio venta": 790,
    "BATERIA": 110,
    "MICA": 90,
    "PANTALLA": 350,
    "TAPA": 90,
    "CHASIS": 300,
    "CAMARA TRASERA": 150,
    "FACE ID": 180,
    "AURICULAR": 80,
    "CRISTAL DE CAMARA": 35,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 150,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Pro Max | 512GB | E-Sim | Usado",
    "Precio recibido iphonizate": 580,
    "Precio recibido orange": 580,
    "Precio venta": 835,
    "BATERIA": 110,
    "MICA": 90,
    "PANTALLA": 350,
    "TAPA": 90,
    "CHASIS": 300,
    "CAMARA TRASERA": 150,
    "FACE ID": 180,
    "AURICULAR": 80,
    "CRISTAL DE CAMARA": 35,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 150,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 15 Pro Max | 1TB | E-Sim | Usado",
    "Precio recibido iphonizate": 600,
    "Precio recibido orange": 600,
    "Precio venta": 885,
    "BATERIA": 110,
    "MICA": 90,
    "PANTALLA": 350,
    "TAPA": 90,
    "CHASIS": 300,
    "CAMARA TRASERA": 150,
    "FACE ID": 180,
    "AURICULAR": 80,
    "CRISTAL DE CAMARA": 35,
    "FLEX BOTONES": 60,
    "FLEX DE CARGA": 150,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 16 | 128GB | E-Sim | Usado",
    "Precio recibido iphonizate": 540,
    "Precio recibido orange": 540,
    "Precio venta": 640,
    "BATERIA": 110,
    "MICA": 200,
    "PANTALLA": 350,
    "TAPA": 100,
    "CHASIS": 300,
    "CAMARA TRASERA": 180,
    "FACE ID": 180,
    "AURICULAR": 100,
    "CRISTAL DE CAMARA": 40,
    "FLEX BOTONES": 80,
    "FLEX DE CARGA": 150,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 16 | 256GB | E-Sim | Usado",
    "Precio recibido iphonizate": 560,
    "Precio recibido orange": 560,
    "Precio venta": 715,
    "BATERIA": 110,
    "MICA": 200,
    "PANTALLA": 350,
    "TAPA": 100,
    "CHASIS": 300,
    "CAMARA TRASERA": 180,
    "FACE ID": 180,
    "AURICULAR": 100,
    "CRISTAL DE CAMARA": 40,
    "FLEX BOTONES": 80,
    "FLEX DE CARGA": 150,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 16 Plus | 128GB | E-Sim | Usado",
    "Precio recibido iphonizate": 560,
    "Precio recibido orange": 560,
    "Precio venta": 755,
    "BATERIA": 120,
    "MICA": 200,
    "PANTALLA": 380,
    "TAPA": 120,
    "CHASIS": 320,
    "CAMARA TRASERA": 200,
    "FACE ID": 200,
    "AURICULAR": 100,
    "CRISTAL DE CAMARA": 40,
    "FLEX BOTONES": 80,
    "FLEX DE CARGA": 160,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 16 plus | 256GB | E-sim | Usado",
    "Precio recibido iphonizate": 580,
    "Precio recibido orange": 580,
    "Precio venta": 740,
    "BATERIA": 120,
    "MICA": 200,
    "PANTALLA": 380,
    "TAPA": 120,
    "CHASIS": 320,
    "CAMARA TRASERA": 200,
    "FACE ID": 200,
    "AURICULAR": 100,
    "CRISTAL DE CAMARA": 40,
    "FLEX BOTONES": 80,
    "FLEX DE CARGA": 160,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 16 Pro | 128GB | E-Sim | Usado",
    "Precio recibido iphonizate": 640,
    "Precio recibido orange": 640,
    "Precio venta": 810,
    "BATERIA": 120,
    "MICA": 250,
    "PANTALLA": 480,
    "TAPA": 120,
    "CHASIS": 400,
    "CAMARA TRASERA": 200,
    "FACE ID": 300,
    "AURICULAR": 100,
    "CRISTAL DE CAMARA": 40,
    "FLEX BOTONES": 80,
    "FLEX DE CARGA": 200,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 16 Pro | 256GB | E-Sim | Usado",
    "Precio recibido iphonizate": 660,
    "Precio recibido orange": 660,
    "Precio venta": 840,
    "BATERIA": 120,
    "MICA": 250,
    "PANTALLA": 480,
    "TAPA": 120,
    "CHASIS": 400,
    "CAMARA TRASERA": 200,
    "FACE ID": 300,
    "AURICULAR": 100,
    "CRISTAL DE CAMARA": 40,
    "FLEX BOTONES": 80,
    "FLEX DE CARGA": 200,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 16 Pro | 512GB | E-Sim | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 880,
    "BATERIA": 120,
    "MICA": 250,
    "PANTALLA": 480,
    "TAPA": 120,
    "CHASIS": 400,
    "CAMARA TRASERA": 200,
    "FACE ID": 300,
    "AURICULAR": 100,
    "CRISTAL DE CAMARA": 40,
    "FLEX BOTONES": 80,
    "FLEX DE CARGA": 200,
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 16 Pro Max | 256GB | E-Sim | Usado",
    "Precio recibido iphonizate": 780,
    "Precio recibido orange": 780,
    "Precio venta": 975,
    "BATERIA": 120,
    "MICA": 300,
    "PANTALLA": 500,
    "TAPA": 120,
    "CHASIS": 400,
    "CAMARA TRASERA": 250,
    "FACE ID": 300,
    "AURICULAR": 100,
    "CRISTAL DE CAMARA": 40,
    "FLEX BOTONES": 100,
    "FLEX DE CARGA": 200,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 16 Pro Max | 512GB | E-Sim | Usado",
    "Precio recibido iphonizate": 810,
    "Precio recibido orange": 810,
    "Precio venta": 1040,
    "BATERIA": 120,
    "MICA": 300,
    "PANTALLA": 500,
    "TAPA": 120,
    "CHASIS": 400,
    "CAMARA TRASERA": 250,
    "FACE ID": 300,
    "AURICULAR": 100,
    "CRISTAL DE CAMARA": 40,
    "FLEX BOTONES": 100,
    "FLEX DE CARGA": 200,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 16 Pro Max | 1TB | E-Sim | Usado",
    "Precio recibido iphonizate": 840,
    "Precio recibido orange": 840,
    "Precio venta": 1100,
    "BATERIA": 120,
    "MICA": 300,
    "PANTALLA": 500,
    "TAPA": 120,
    "CHASIS": 400,
    "CAMARA TRASERA": 250,
    "FACE ID": 300,
    "AURICULAR": 100,
    "CRISTAL DE CAMARA": 40,
    "FLEX BOTONES": 100,
    "FLEX DE CARGA": 200,
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 17e | 256GB | E-Sim | Usado",
    "Precio recibido iphonizate": 400,
    "Precio recibido orange": 400,
    "Precio venta": "",
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "trade-in"
  },
  {
    "Modelo": "iPhone 17 Air | 256GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 700,
    "Precio recibido orange": 700,
    "Precio venta": "",
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "trade-in"
  },
  {
    "Modelo": "iPhone 17 | 256GB | E-Sim | Usado",
    "Precio recibido iphonizate": 650,
    "Precio recibido orange": 650,
    "Precio venta": "",
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "trade-in"
  },
  {
    "Modelo": "iPhone 17 Pro | 256GB | E-Sim | Usado",
    "Precio recibido iphonizate": 840,
    "Precio recibido orange": 840,
    "Precio venta": 1160,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 17 Pro | 512GB | Single-Sim | Usado",
    "Precio recibido iphonizate": 860,
    "Precio recibido orange": 860,
    "Precio venta": "",
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "trade-in"
  },
  {
    "Modelo": "iPhone 17 Pro Max | 256GB | E-Sim | Usado",
    "Precio recibido iphonizate": 920,
    "Precio recibido orange": 920,
    "Precio venta": 1280,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 17 Pro Max | 512GB | E-Sim | Usado",
    "Precio recibido iphonizate": 960,
    "Precio recibido orange": 960,
    "Precio venta": 1465,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "trade-in,venta"
  },
  {
    "Modelo": "iPhone 17 Pro Max | 1TB | E-Sim | Usado",
    "Precio recibido iphonizate": 1000,
    "Precio recibido orange": 1000,
    "Precio venta": "",
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "trade-in"
  },
  {
    "Modelo": "iPhone 17 Pro Max | 2TB | E-Sim | Usado",
    "Precio recibido iphonizate": 1040,
    "Precio recibido orange": 1040,
    "Precio venta": "",
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "trade-in"
  },
  {
    "Modelo": "iPhone 13 | 128GB | Single-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 500,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 14 | 128GB | E-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 570,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 13 | 128GB | Single-Sim | Open Box",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 505,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 14 | 128GB | E-Sim | Open Box",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 555,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 14 Plus | 128GB | E-Sim | Open Box",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 625,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 15 | 128GB | Single-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 685,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 17 | 256GB | E-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 1025,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 16 | 128GB | Single-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 810,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 17 Pro | 256GB | E-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 1320,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 17 Pro | 256GB | Single-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 1450,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": ""
  },
  {
    "Modelo": "iPhone 17 Pro Max | 256GB | E-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 1390,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 17 Pro Max | 256GB | Silver | E-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 1390,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 17 Pro Max | 256GB |Single-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 1505,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": ""
  },
  {
    "Modelo": "iPhone 17 Pro Max | 512GB | E-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 1675,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 17 Pro Max | 512GB | Single-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 1795,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": ""
  },
  {
    "Modelo": "iPhone 17 Pro Max | 1TB | E-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 1840,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": ""
  },
  {
    "Modelo": "iPhone Air | 256GB | E-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 990,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 18 Pro | 256GB | E-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 1480,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 18 Pro | 512GB | E-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 1800,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": ""
  },
  {
    "Modelo": "iPhone 18 Pro Max | 256GB | E-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 1730,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 18 Pro Max | 256GB | Burgundy | E-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 1885,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 18 Pro Max | 512GB | E-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 1950,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPhone 18 Pro Max | 1TB | E-Sim | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 2450,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": ""
  },
  {
    "Modelo": "Apple Watch S5 | 40MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 140,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S7 | 45MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 185,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S8 | 41MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 185,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S8 | 41MM | GPS | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 185,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S8 | 45MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 200,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S8 | 45MM | GPS | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 200,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S9 | 41MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 210,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S9 | 41MM | GPS | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 210,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S9 | 45MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 230,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S9 | 45MM | GPS | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 230,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S10 | 42MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 245,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S10 | 42MM | GPS | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 245,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S10 | 46MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 260,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S10 | 46MM | GPS | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 260,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S11 | 42MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 275,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S11 | 42MM | GPS | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 275,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S11 | 46MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 295,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S11 | 46MM | GPS | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 295,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch SE 1ra | 44MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 100,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch SE 2da | 40MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 140,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch SE 2da | 44MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 150,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch SE 3ra | 40MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 180,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch SE 3ra | 44MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 180,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch Ultra | 49MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 360,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch Ultra 2 | 49MM | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 385,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S11 | 42MM | GPS | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 395,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch S11 | 46MM | GPS | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 275,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Apple Watch Ultra 2 | 49MM | Cell | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 385,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPad 7th Gen | 32GB | Wifi | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 90,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPad 8th Gen | 128GB | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 180,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPad 9th Gen | 64GB | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 215,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPad 9th Gen | 256GB | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 255,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPad 10th Gen | 64GB | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 275,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPad Air 4th Gen | 64GB | Cell | Usado",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 275,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "iPad 11th Gen 11\" A16 | 128GB | Wifi | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 500,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Airpods 3 | Original | Wireless | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 110,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Airpods 4 | Original | Wireless | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 145,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "AirPods Pro 2da Gen | Original | Wireless | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 200,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  },
  {
    "Modelo": "Airpods Pro 3 | Original Noise Cancellation | Wireless | Nuevo",
    "Precio recibido iphonizate": "",
    "Precio recibido orange": "",
    "Precio venta": 275,
    "BATERIA": "",
    "MICA": "",
    "PANTALLA": "",
    "TAPA": "",
    "CHASIS": "",
    "CAMARA TRASERA": "",
    "FACE ID": "",
    "AURICULAR": "",
    "CRISTAL DE CAMARA": "",
    "FLEX BOTONES": "",
    "FLEX DE CARGA": "",
    "Tipo": "venta"
  }
]